import React, { useCallback } from 'react';

interface ModalProps {
  isOpen: boolean;
  maxWidth?: string;
  sidebarOffset?: boolean;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  children,
  maxWidth = '50%',
  sidebarOffset = true,
}) => {
  const getInnerContainerClassName = useCallback(() => {
    let className = [
      'bg-white rounded-lg relative w-[90%] min-w-[30rem] z-[1001] shadow',
    ];

    if (sidebarOffset) {
      className.push(`lg:ml-[17.5rem]`);
    }

    return className.join(' ');
  }, [sidebarOffset]);

  if (!isOpen) return <></>;

  return (
    <div className="overflow-y-auto fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div
        style={{ background: 'white', maxWidth }}
        className={getInnerContainerClassName()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
